__turbopack_context__.v({
  "arrowRight": "Spinner-module-scss-module__enzGqq__arrowRight",
  "button": "Spinner-module-scss-module__enzGqq__button",
  "buttonIcon": "Spinner-module-scss-module__enzGqq__buttonIcon",
  "buttonWrapper": "Spinner-module-scss-module__enzGqq__buttonWrapper",
  "image": "Spinner-module-scss-module__enzGqq__image",
  "spinnerWrapper": "Spinner-module-scss-module__enzGqq__spinnerWrapper",
});
